import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_create-boarding _modal bg-white" }
const _hoisted_2 = { class: "_modal__content px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    height: "60",
    viewBox: "0 0 60 60",
    width: "60",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M29.8034 3.38292C15.2228 3.38292 3.36674 15.3238 3.36674 30.001C3.36674 44.6762 15.2228 56.6171 29.8034 56.6171C44.3839 56.6171 56.2452 44.6762 56.2452 30.001C56.2452 15.3238 44.3839 3.38292 29.8034 3.38292ZM29.8034 60C13.3737 60 0 46.5418 0 30.001C0 13.4582 13.3737 0 29.8034 0C46.2382 0 59.6068 13.4582 59.6068 30.001C59.6068 46.5418 46.2382 60 29.8034 60Z",
      fill: "#F4C870"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M52.555 30.0011C52.555 42.6493 42.3697 52.9026 29.8011 52.9026C17.2376 52.9026 7.05222 42.6493 7.05222 30.0011C7.05222 17.3518 17.2376 7.09799 29.8011 7.09799C42.3697 7.09799 52.555 17.3518 52.555 30.0011Z",
      fill: "#F4C870"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M42.5166 30C42.5166 37.0692 36.8237 42.7999 29.8013 42.7999C22.7789 42.7999 17.0861 37.0692 17.0861 30C17.0861 22.9307 22.7789 17.2 29.8013 17.2C36.8237 17.2 42.5166 22.9307 42.5166 30ZM25.6771 26.8523C25.5407 26.8523 25.4288 26.7423 25.4325 26.6059C25.5094 23.7792 27.7598 22.8 29.8099 22.8C32.0295 22.8 34.0574 23.9679 34.0574 26.3851C34.0574 28.1117 33.0485 28.9343 32.0799 29.6757C30.9096 30.5695 30.4758 30.9046 30.4758 32.0523V32.371C30.4758 32.5091 30.3638 32.621 30.2258 32.621H28.6441C28.5073 32.621 28.3959 32.5112 28.3941 32.3744L28.3873 31.8796C28.3268 30.3968 29.1743 29.4828 30.2437 28.7007C31.182 27.9898 31.7772 27.5226 31.7772 26.507C31.7772 25.1867 30.7784 24.6382 29.6888 24.6382C28.3533 24.6382 27.6315 25.4767 27.5398 26.6024C27.5286 26.7401 27.4178 26.8523 27.2798 26.8523H25.6771ZM29.5173 37.1609C28.5891 37.1609 27.9132 36.5312 27.9132 35.6781C27.9132 34.7945 28.5891 34.1749 29.5173 34.1749C30.4859 34.1749 31.1517 34.7945 31.1517 35.6781C31.1517 36.5312 30.4859 37.1609 29.5173 37.1609Z",
      fill: "white",
      "fill-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center" }
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, " Xóa " + _toDisplayString($props.data.length) + " buổi học ", 1),
      _createElementVNode("div", _hoisted_5, " Bạn chắc chắn muốn xóa " + _toDisplayString($props.data.length) + " buổi học này? ", 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, " Huỷ "),
      _createElementVNode("button", {
        class: "button-p text-center whitespace-nowrap",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit')))
      }, " Xác nhận ")
    ])
  ]))
}